import { ApolloCache, useMutation } from '@apollo/client';
import type { VirtualMonitorSplit } from 'generated/graphql';
import { TOGGLE_VIRTUAL_MONITOR_SPLIT, GET_ME } from 'modules/Apollo/queries';
import { useCurrentUser } from './useCurrentUser';
import assocPath from 'ramda/es/assocPath';
import { notifyUserSettingsUpdate } from './notifyUserSettingsUpdate';
import { WithApolloContext } from 'modules/Apollo/types';

export const useVirtualMonitorSplitToggle = ({
  context,
}: WithApolloContext): [
  VirtualMonitorSplit | null,
  (arg1: VirtualMonitorSplit | null) => Promise<void>,
] => {
  const { data, refetch: refetchUser } = useCurrentUser({ context });
  const me = data?.me;
  const virtualMonitorSplit = me?.viewerSettings?.virtualMonitorSplit ?? null;

  const [saveVirtualMonitorSplitValue] = useMutation(TOGGLE_VIRTUAL_MONITOR_SPLIT, {
    onCompleted: () => {
      // refetchUser();
      notifyUserSettingsUpdate();
    },
    onError: () => {
      refetchUser();
    },
    update(cache: ApolloCache<unknown>, res, { variables }) {
      if (me == null) {
        return;
      }

      const { virtualMonitorSplit } = variables || {
        virtualMonitorSplit: null,
      };

      cache.writeQuery({
        query: GET_ME,
        data: assocPath(['me', 'viewerSettings', 'virtualMonitorSplit'], virtualMonitorSplit, data),
      });
    },
    context,
  });

  const toggleVirtualMonitorSplit = async (virtualMonitorSplit: VirtualMonitorSplit | null) => {
    await saveVirtualMonitorSplitValue({
      variables: {
        virtualMonitorSplit,
      },
      optimisticResponse: {
        __typename: 'Mutation',
        toggleVirtualMonitorSplit: {
          virtualMonitorSplit,
          __typename: 'VirtualMonitorSplitResponse',
        },
      },
    });
  };

  return [virtualMonitorSplit, toggleVirtualMonitorSplit];
};
